module.exports = __webpack_public_path__ + "img/3-2.2a3ba36.jpg";